exports = module.exports = require("../../../../../../../../../../../../web-hosted/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".RatingIconDropLayer__RatingIconDropLayerContainer__3Dq6N {\n  width: 100%;\n  height: 100%;\n  -webkit-transition: all 0.15s ease-in;\n  -o-transition: all 0.15s ease-in;\n  transition: all 0.15s ease-in;\n}\n\n.RatingIconDropLayer__RatingIconDropLayer__smQT2 {\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  -webkit-box-shadow: 0 8px 6px -6px lightgray;\n          box-shadow: 0 8px 6px -6px lightgray;\n}\n", ""]);

// exports
exports.locals = {
	"RatingIconDropLayerContainer": "RatingIconDropLayer__RatingIconDropLayerContainer__3Dq6N",
	"RatingIconDropLayer": "RatingIconDropLayer__RatingIconDropLayer__smQT2"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/containers/Mainpage/containers/SingleTaskPage/WorkspaceView/Structures/TableView/TableCell/RegularCell/RatingIconDropLayer/RatingIconDropLayer.css
// module id = 840
// module chunks = 0